import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { ROUTES } from '@app/constants'

import SubMenuContainer from './SubMenuContainer'

export interface SubListLinkProps {
  isOpen: boolean
  mouseLeave: () => void
  mouseEnter: () => void
}

const SubListLink = styled(Link)`
  font-size: 1.5rem;
  line-height: 2.6rem;
  margin: 1rem 0;
  color: ${({ theme }) => theme.global.colors.genoa};
  text-transform: capitalize;

  :hover {
    color: ${({ theme }) => `${theme.global.colors.elemyGreen}`};
  }

  :active {
    color: ${({ theme }) => `${theme.global.colors.genoa}`};
  }

  &:last-child {
    margin-bottom: 0;
  }

  &:first-child {
    margin-top: 0;
  }
`

const SubLinks = ({ isOpen, mouseLeave, mouseEnter }: SubListLinkProps) => {
  return (
    <SubMenuContainer rightOffset={-5} isOpen={isOpen} mouseLeave={mouseLeave} mouseEnter={mouseEnter} linksOnly>
      <SubListLink to={ROUTES.ourStory}>Our Story</SubListLink>
      <SubListLink to={ROUTES.ourClinicians}>Our Providers</SubListLink>
      <SubListLink to={ROUTES.corporateCareers}>Careers</SubListLink>
      <SubListLink to={ROUTES.contactUs}>Contact Us</SubListLink>
    </SubMenuContainer>
  )
}

export default SubLinks
